import * as React from 'react';

import QrReader from 'react-qr-reader';

import { FormattedMessage } from 'react-intl';
import { RouteComponentProps } from 'react-router';

import { Button } from 'components/Button';
import { LayoutHeader } from 'components/Layout';
import { ROUTE_WALLET_TRANSFER_PHONE, ROUTE_WALLET_TRANSFER_PHONE_WITH_PARAM } from 'constants/app';
import { isValidPhone } from 'helper/form';

import './WalletTransferQrCode.scss';

type WalletTransferQrCodeProps = RouteComponentProps<{}>;

interface WalletTransferQrCodeError {
  constraint: string;
  message: string;
  name: string;
}

interface WalletTransferQrCodeState {
  isUploadQrDataInvalid: boolean;
  isLegacyModeActive: boolean;
}

interface QrReader {
  openImageDialog: () => void;
}

export class WalletTransferQrCode extends React.Component<WalletTransferQrCodeProps, WalletTransferQrCodeState> {
  private qrReader: QrReader;

  constructor(props: WalletTransferQrCodeProps) {
    super(props);

    this.state = {
      isLegacyModeActive: false,
      isUploadQrDataInvalid: false
    };
    this.goToWalletTransferPhone = this.goToWalletTransferPhone.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleScan = this.handleScan.bind(this);
    this.openImageDialog = this.openImageDialog.bind(this);
    this.setQrReaderRef = this.setQrReaderRef.bind(this);
  }

  render() {
    const delay = 300;
    const style = { width: '100%' };
    const { isLegacyModeActive } = this.state;
    return (
      <div className="o-container o-container--fluid o-container--fluid-vertical">
        <LayoutHeader actionIcon="ic-close" actionHandler={this.goToWalletTransferPhone}>
          <h1 className="o-layout-header-title"><FormattedMessage id="wallet.transfer.title"/></h1>
        </LayoutHeader>
        <QrReader
          ref={this.setQrReaderRef}
          delay={delay}
          onError={this.handleError}
          onScan={this.handleScan}
          style={style}
          legacyMode={isLegacyModeActive}
        />
        {this.errorFootnote}
        {this.buttonSubmitQr}
      </div>
    );
  }

  get buttonSubmitQr() {
    const { isLegacyModeActive } = this.state;
    if (isLegacyModeActive) {
      return (
        <Button onClick={this.openImageDialog} type="button" className="button--full button--primary o-form-button">
          <FormattedMessage id="wallet.transfer.qrCode.submit"/>
        </Button>
      );
    }
    return null;
  }

  get errorFootnote() {
    if (this.state.isUploadQrDataInvalid) {
      return (
        <p className="wallet-transfer-qr-code__error-footnote">
          <FormattedMessage id="wallet.transfer.qrCode.invalidData"/>
        </p>
      );
    }
    return null;
  }

  private goToWalletTransferPhone() {
    const { history } = this.props;
    history.replace(ROUTE_WALLET_TRANSFER_PHONE);
  }

  private handleError(error: WalletTransferQrCodeError) {
    this.setState({ isLegacyModeActive: true });
    console.error(error); // tslint:disable-line
  }

  private handleScan(data: string | null) {
    if (!data && this.state.isLegacyModeActive) {
      this.setState({ isUploadQrDataInvalid: true });
    }

    if (data && isValidPhone(data)) {
      this.setState({ isUploadQrDataInvalid: false });

      const { history } = this.props;
      const newPath = ROUTE_WALLET_TRANSFER_PHONE_WITH_PARAM.replace(':phone', data);
      history.replace(newPath);
    }
  }

  private openImageDialog() {
    this.qrReader.openImageDialog();
  }

  private setQrReaderRef(qrReader: QrReader) {
    this.qrReader = qrReader;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Wallet/WalletTransferQrCode/WalletTransferQrCode.tsx